jQuery($ => {
    class AddToQuoteButton {
      constructor(element) {
        this._        = element;
        this._element = $(element);
        this._ajaxRunning = false;

        this._isButton = this._element.hasClass('a-button');
        this._isArrowLink = this._element.hasClass('a-arrow-link');
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'init', this );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      handleClick() {
        if (this._ajaxRunning) {
          return;
        }
  
        const productId = this._element.data('product-id');
        const productName = this._element.data('product-name');
        const nonce = this._element.data('nonce');
  
        if (!productId || !nonce) {
          return;
        }        

        const originalText = this._element.text();
        const loadingText = this._element.data('loading-text');
        const successText = this._element.data('success-text');
        const successIcon = this._element.data('success-icon');
  
        $.ajax({
          type: 'POST',
          url: wc_add_to_cart_params.wc_ajax_url.toString().replace( '%%endpoint%%', 'add_to_cart' ),
          data: {
            'action': 'add_to_cart',
            'product_id': productId,
            'quantity': 1,
            'nonce': nonce,
          },
          beforeSend: () => {
            this._ajaxRunning = true;

            this._element.addClass('m-add-to-quote-button--loading');
            this._element.attr('disabled', 'disabled');

            if (this._isButton) {
              this._element.find('.a-button__text').text(loadingText);
              this._element.find('.a-button__icon').hide();
            } else if (this._isArrowLink) {
              this._element.find('.a-arrow-link__text').text(loadingText);
              this._element.find('.a-arrow-link__icon').hide();
            }
          },
          success: (result) => {
            if (result?.cart_hash) {
              if (this._isButton) {
                this._element.find('.a-button__text').text(successText);
                this._element.find('.a-button__icon').show();
              } else if (this._isArrowLink) {
                this._element.find('.a-arrow-link__text').text(successText);
                if (successIcon) {
                  this._element.find('.a-arrow-link__icon').html(atob(successIcon));
                }
                this._element.find('.a-arrow-link__icon').show();
              }

              // Update quote indicator in header
              const currentQuoteIndicators = $('.m-current-quote-indicator');
              if (currentQuoteIndicators.length) {
                currentQuoteIndicators.each(function() {
                  this.current_quote_indicator.update_quote_count();
                });
              }

              // Show toast bar
              const toastBars = $('.o-toast-bar');
              toastBars.each(function() {
                if ($(this).attr('id') === 'products-archive-toast' || $(this).attr('id') === 'product-single-toast') {
                  this.toast_bar.handleShow(productName);
                }
              });
            } else {
              if (this._isButton) {
                this._element.find('.a-button__text').text(originalText);
                this._element.find('.a-button__icon').show();
              } else if (this._isArrowLink) {
                this._element.find('.a-arrow-link__text').text(originalText);
                this._element.find('.a-arrow-link__icon').show();
              }
            }
          },
          error: function(error) {
            console.error(error);

            if (this._isButton) {
              this._element.find('.a-button__text').text(originalText);
              this._element.find('.a-button__icon').show();
            } else if (this._isArrowLink) {
              this._element.find('.a-arrow-link__text').text(originalText);
              this._element.find('.a-arrow-link__icon').show();
            }
          },
          complete: () => {
            this._ajaxRunning = false;
            this._element.removeClass('m-add-to-quote-button--loading');
            this._element.removeAttr('disabled');
          }
        })
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on('click', () => this.handleClick());
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.add_to_quote_button = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].add_to_quote_button = new AddToQuoteButton(_[i], opt);
        else
          ret = _[i].add_to_quote_button[opt].apply(_[i].add_to_quote_button, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.m-add-to-quote-button').add_to_quote_button();
});